module.exports = "https://static.cdns.space/tarot-temp/img/the-empress.63ace8bd.webp";